<div [ngStyle]="{ width: '705px' }" class="modal">
  <div class="modal__header">
    <h6 class="title" [innerHTML]="'Форма зворотнього зв’язку'"></h6>

    <button (click)="close()" class="btn-close">
      <img src="assets/img/icons/close-new.svg" alt="" />
    </button>
  </div>

  <mat-dialog-content class="modal__content">
    <ng-content></ng-content>
  </mat-dialog-content>
</div>
